var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Collapse",style:(_vm.styles)},[_vm._t("header"),_c('FadeHeightTransition',[(_vm.opened)?_c('div',[_vm._t("default")],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }